module.exports = __webpack_public_path__ + "img/材料力学6_5.0927fcd2.jpg";